export default {
  updateUser (state, payload) {
    state.user = payload
  },
  loading (state, payload) {
    state.loading = payload
  },
  updateExpired (state, payload) {
    state.expired = payload
  },
  updateQuery (state, payload) {
    state.query = payload
  },
  updateMenu (state, payload) {
    state.menu = payload
  },
  updateCustomer (state, payload) {
    state.customer = payload
  },
  updateGroupon (state, payload) {
    state.groupon = payload
  },
  updateWxState (state, payload) {
    state.wxReady = payload
  },
  updateWxToken (state, payload) {
    state.wxToken = payload
  },
  updateLocation (state, payload) {
    state.location = payload
  }
}
